import { render, staticRenderFns } from "./game-type-new.vue?vue&type=template&id=3cb63bd2&"
import script from "./game-type-new.vue?vue&type=script&lang=js&"
export * from "./game-type-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports